import * as React from 'react';

import { RadioGroup, RadioGroupItem } from './components/ui/radio-group.js';

export type DimeRadioGroupProps = React.ComponentProps<typeof RadioGroup>;
export type DimeRadioGroupItemProps = React.ComponentProps<typeof RadioGroupItem>;

export function DimeRadioGroup({ ...props }: Readonly<DimeRadioGroupProps>) {
  return <RadioGroup {...props} />;
}

DimeRadioGroup.displayName = 'DimeRadioGroup';

export function DimeRadioGroupItem({ ...props }: Readonly<DimeRadioGroupItemProps>) {
  return <RadioGroupItem {...props} />;
}

DimeRadioGroupItem.displayName = 'DimeRadioGroupItem';
